module.exports = __webpack_public_path__ + "static/fonction6-3f6aaa7f307bdf990becf1a82d01c157.jpg";